import React, { Fragment, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Footer from '../container/Footer';
import Header from '../container/Header';
import SearchForm from '../container/SearchForm';
import Paging from '../container/Paging';
import Center from 'react-center';
import { isBrowser } from 'react-device-detect';
import { zipFiles, downloadZip } from '../../utils/zipUtils';
import HttpClient from '../../utils/HttpClient';
import { getTitle } from '../../utils/documentUtils';

const SearchTab = ({ documents, saveSearch }) => {
    const [searchCriteria, setSearchCriteria] = useState();
    const [zipping, setZipping] = useState(false);
    const handleSaveSearch = async () => {
        if (searchCriteria) {
            const sc = searchCriteria;
            setSearchCriteria(undefined);
            saveSearch(sc);
        }
    }

    const handleZip = async () => {
        console.log("handleZip");
        if(zipping) return;
        setZipping(true);
        const docs = [];
        for (const doc of documents) {
            const url = await new HttpClient().download(doc.id.value);
            docs.push({ metadata: doc, url, title: getTitle(doc) });
        }
        const name = "tindyds";
        zipFiles(name, ...docs).then(zip => {
            downloadZip(zip, name);
        }).finally(() => {
            setZipping(false);
        });
    }

    const getMobileView = () => {
        return (
            <Fragment>
                <Center>
                    <SearchForm setSearchCriteria={setSearchCriteria} />
                </Center>
                <Center>
                    <Paging saveSearch={searchCriteria ? handleSaveSearch : undefined} handleZip={handleZip} zipping={zipping} />
                </Center>
            </Fragment>
        )
    }

    const getBrowserView = () => {
        return (
            <Row noGutters className="pt-2 pt-md-5 w-100 px-4 px-xl-0 mb-3 position-relative">
                <Col key={1} xs={{ order: 1 }} md={{ size: 2, order: 1 }} tag="aside" className="pb-5 mb-5 pb-md-0 mb-md-0 mx-auto mx-md-0">
                    <SearchForm setSearchCriteria={setSearchCriteria} />
                </Col>
                <Col key={2} xs={{ order: 2 }} md={{ size: 9, offset: 1 }} tag="section" className="py-5 mb-5 py-md-0 mb-md-0">
                    <Paging saveSearch={searchCriteria ? handleSaveSearch : undefined} handleZip={handleZip} zipping={zipping} />
                </Col>
            </Row>
        )
    }

    const getView = () => {
        return isBrowser ? getBrowserView() : getMobileView();
    }

    return (
        <Container className="px-0">
            <Header />
            {getView()}
            <Footer />
        </Container>
    )
}


export default SearchTab;
